import React, { useState } from 'react';
import './Login.css';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';

function Login({ onLogin, userPool }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    if (!email || !password) {
      setError('Please fill in all fields');
      setIsLoading(false);
      return;
    }

    const authenticationData = {
      Username: email,
      Password: password,
    };

    const authenticationDetails = new AuthenticationDetails(authenticationData);

    const userData = {
      Username: email,
      Pool: userPool,
    };

    const cognitoUser = new CognitoUser(userData);

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: async (session) => {
        console.log('Authentication successful');
        const idToken = session.getIdToken().getJwtToken();
        await onLogin(cognitoUser, idToken);
        setIsLoading(false);
      },
      onFailure: (err) => {
        console.error('Authentication failed:', err);
        setError(err.message || 'Invalid email or password');
        setIsLoading(false);
      },
      newPasswordRequired: (userAttributes) => {
        // User needs to set a new password
        setError('New password required. Please contact administrator.');
        setIsLoading(false);
      },
    });
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Bedrock Chat</h1>
        <p className="subtitle">Sign in with your Cognito account</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              autoComplete="email"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div className="demo-credentials">
          <p className="demo-note">Note:</p>
          <p className="demo-text">Users must be created by an administrator.</p>
          <p className="demo-text">Self-registration is disabled.</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
